// Tidemark projects. Each project has a `photos` array — the carousel on the
// Projects page cycles through these images. Replace with real project imagery
// as it becomes available.
export const projects = [
  {
    slug: "red-hill-residence",
    title: "Red Hill Residence",
    location: "Red Hill, Victoria",
    year: "2023",
    category: "New Build",
    summary: "",
    photos: [
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/olyp12vm_DSC09964_emergent.jpg",
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/6j3unww6_DSC09918_emergent.jpg",
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/5qgljndj_DSC09925_1__emergent.jpg",
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/53clb091_DSC09968_emergent.jpg",
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/4fup1v2f_DSC09977_emergent.jpg",
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/p2918srf_DSC09845_emergent.jpg",
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/g75zkwgc_DSC00012_emergent.jpg",
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/g3fn7tk3_DSC00019_emergent.jpg",
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/2pdb6mfl_DSC09887_emergent.jpg",
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/ezhu7g51_DSC00031_emergent.jpg",
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/6wsf9lmj_DSC09997_emergent.jpg",
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/pfqwxq8c_IMG_4189_emergent.jpg",
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/ycnfh4oq_DSC09827_wide.jpg",
    ],
  },
  {
    slug: "mt-eliza-residence",
    title: "Mt Eliza Residence",
    location: "Mt Eliza, Victoria",
    year: "2025",
    category: "New Build",
    summary: "",
    photos: [
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/47f1e19o_IMG_4916_emergent.jpg",
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/rebwzjft_IMG_4922_emergent.jpg",
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/rhom5sda_IMG_4929_emergent.jpg",
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/ih1tgpgy_IMG_4931_emergent.jpg",
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/0ue59b6k_IMG_5530_emergent.jpg",
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/yl4c0zb5_IMG_5540_emergent.jpg",
    ],
  },
  {
    slug: "albert-park-residence",
    title: "Albert Park Residence",
    location: "Albert Park, Victoria",
    year: "2025",
    category: "1st Stage Renovation",
    summary: "",
    photos: [
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/y1su0i95_albert_park1_emergent.jpg",
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/i1bqsjdt_ab2_emergent.jpg",
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/4x0cg6rh_IMG_5023_emergent.jpg",
      "https://customer-assets.emergentagent.com/job_premium-builds-vic/artifacts/j7ubx5f8_IMG_5033_emergent%20%281%29.jpg",
    ],
  },
];
